import {
  ThemeSelectors,
  TypeInsignia,
  TypeToledo,
} from "@at/design-system-foundation";
import styled from "styled-components";

export const Content = styled.section`
  + div {
    margin-top: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};

    .atds-modal--close {
      width: 100%;
      border-radius: 40px;
      padding: ${({ theme }) =>
        `${ThemeSelectors.getGroupFourSpacing(
          theme,
        )} ${ThemeSelectors.getGroupFiveSpacing(theme)}`};
    }
  }
`;

export const Body = styled.div`
  margin-bottom: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
`;

export const Title = styled(TypeInsignia).attrs({ as: "h3" })`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  font-variation-settings: "wght" 400;
`;

export const Subheading = styled(TypeToledo).attrs({ as: "h4", weight: 400 })`
  margin: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)} 0;
`;

export const HighlightedPoint = styled.div`
  margin: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)} 0;
  padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  background-color: rgba(195, 208, 244, 0.2);
  border-radius: calc(
    ${({ theme }) => ThemeSelectors.getBorderRadius(theme)} + 2px
  );
`;

export const HighlightedText = styled.span`
  font-variation-settings: "wght" 500;
`;
